import React, { useState } from 'react';
import { MapPinIcon, PhoneIcon, MailIcon, ClockIcon } from 'lucide-react';
export function ContactSection() {
  const [formStatus, setFormStatus] = useState<'idle' | 'submitting' | 'success'>('idle');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setFormStatus('submitting');
    // Simulate form submission
    setTimeout(() => {
      setFormStatus('success');
      // Reset form after 3 seconds
      setTimeout(() => setFormStatus('idle'), 3000);
    }, 1000);
  };
  return <section id="contact" className="bg-white py-24 px-4 sm:px-6 lg:px-8" data-id="element-11">
      <div className="max-w-7xl mx-auto" data-id="element-12">
        <div className="text-center mb-16" data-id="element-13">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-14">
            Get Your Free Quote
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-15">
            Ready to experience the Bright & Clean difference? Fill out the form
            below and our team will get back to you within 24 hours.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start" data-id="element-16">
          {/* Contact Information */}
          <div data-id="element-17">
            <h3 className="text-2xl font-bold text-gray-900 mb-8" data-id="element-18">
              Contact Information
            </h3>

            <div className="space-y-8" data-id="element-19">
              <div className="flex items-start gap-4" data-id="element-20">
                <div className="w-12 h-12 bg-[#0E7C86]/10 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-21">
                  <PhoneIcon className="w-6 h-6 text-[#0E7C86]" data-id="element-22" />
                </div>
                <div data-id="element-23">
                  <h4 className="text-lg font-semibold text-gray-900 mb-1" data-id="element-24">
                    Phone
                  </h4>
                  <p className="text-gray-600" data-id="element-25">(555) 123-4567</p>
                  <p className="text-sm text-gray-500 mt-1" data-id="element-26">
                    Mon-Fri from 8am to 6pm
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-27">
                <div className="w-12 h-12 bg-[#0E7C86]/10 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-28">
                  <MailIcon className="w-6 h-6 text-[#0E7C86]" data-id="element-29" />
                </div>
                <div data-id="element-30">
                  <h4 className="text-lg font-semibold text-gray-900 mb-1" data-id="element-31">
                    Email
                  </h4>
                  <p className="text-gray-600" data-id="element-32">info@brightandclean.com</p>
                  <p className="text-sm text-gray-500 mt-1" data-id="element-33">
                    We'll respond within 24 hours
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-34">
                <div className="w-12 h-12 bg-[#0E7C86]/10 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-35">
                  <MapPinIcon className="w-6 h-6 text-[#0E7C86]" data-id="element-36" />
                </div>
                <div data-id="element-37">
                  <h4 className="text-lg font-semibold text-gray-900 mb-1" data-id="element-38">
                    Service Area
                  </h4>
                  <p className="text-gray-600" data-id="element-39">
                    Serving the Greater Metro Area
                  </p>
                  <p className="text-sm text-gray-500 mt-1" data-id="element-40">
                    Available for multi-location businesses
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-41">
                <div className="w-12 h-12 bg-[#0E7C86]/10 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-42">
                  <ClockIcon className="w-6 h-6 text-[#0E7C86]" data-id="element-43" />
                </div>
                <div data-id="element-44">
                  <h4 className="text-lg font-semibold text-gray-900 mb-1" data-id="element-45">
                    Cleaning Hours
                  </h4>
                  <p className="text-gray-600" data-id="element-46">24/7 Service Available</p>
                  <p className="text-sm text-gray-500 mt-1" data-id="element-47">
                    Daytime, evening, and weekend crews
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="bg-[#F5F7FA] rounded-2xl p-8 shadow-sm border border-gray-100" data-id="element-48">
            <h3 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-49">
              Send us a message
            </h3>

            {formStatus === 'success' ? <div className="bg-green-50 border border-green-200 rounded-xl p-6 text-center" data-id="element-50">
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-51">
                  <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-52">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-53"></path>
                  </svg>
                </div>
                <h4 className="text-xl font-bold text-green-900 mb-2" data-id="element-54">
                  Message Sent!
                </h4>
                <p className="text-green-700" data-id="element-55">
                  Thank you for reaching out. We'll get back to you shortly with
                  your free quote.
                </p>
              </div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-56">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-57">
                  <div data-id="element-58">
                    <label htmlFor="firstName" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-59">
                      First Name *
                    </label>
                    <input type="text" id="firstName" required className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#0E7C86] focus:border-[#0E7C86] outline-none transition-colors" placeholder="John" data-id="element-60" />
                  </div>
                  <div data-id="element-61">
                    <label htmlFor="lastName" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-62">
                      Last Name *
                    </label>
                    <input type="text" id="lastName" required className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#0E7C86] focus:border-[#0E7C86] outline-none transition-colors" placeholder="Doe" data-id="element-63" />
                  </div>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-64">
                  <div data-id="element-65">
                    <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-66">
                      Email Address *
                    </label>
                    <input type="email" id="email" required className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#0E7C86] focus:border-[#0E7C86] outline-none transition-colors" placeholder="john@company.com" data-id="element-67" />
                  </div>
                  <div data-id="element-68">
                    <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-69">
                      Phone Number
                    </label>
                    <input type="tel" id="phone" className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#0E7C86] focus:border-[#0E7C86] outline-none transition-colors" placeholder="(555) 123-4567" data-id="element-70" />
                  </div>
                </div>

                <div data-id="element-71">
                  <label htmlFor="company" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-72">
                    Company Name
                  </label>
                  <input type="text" id="company" className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#0E7C86] focus:border-[#0E7C86] outline-none transition-colors" placeholder="Acme Corp" data-id="element-73" />
                </div>

                <div data-id="element-74">
                  <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-75">
                    How can we help? *
                  </label>
                  <textarea id="message" rows={4} required className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#0E7C86] focus:border-[#0E7C86] outline-none transition-colors resize-none" placeholder="Tell us about your facility and cleaning needs..." data-id="element-76"></textarea>
                </div>

                <button type="submit" disabled={formStatus === 'submitting'} className="w-full bg-[#6BBF3B] text-white px-8 py-4 rounded-lg font-semibold hover:bg-[#5aa832] transition-colors flex items-center justify-center disabled:opacity-70" data-id="element-77">
                  {formStatus === 'submitting' ? 'Sending...' : 'Request Free Quote'}
                </button>
              </form>}
          </div>
        </div>
      </div>
    </section>;
}